import { Link } from "react-router-dom";

const NewsCard = ({
    image,
    imageAlt = "News image",
    link = "#",
    title,
    labels = [],
    summary = ""
}) => {
    return (
        <div className="newsCard">
            <Link to={link}>
                <img
                    className="newsCard__img"
                    src={image}
                    alt={imageAlt}
                />
            </Link>

            <div className="newsCard__title">
                <Link to={link}>
                    {title}
                </Link>
            </div>

            <div className="newsCard__labels">
                {labels.map((label, index) => (
                    <div
                        className="newsCard__label"
                        key={index}
                    >
                        {label}
                    </div>
                ))}
            </div>

            <div>
                {summary}
            </div>
        </div>
    );
};

export default NewsCard;